import { createSlice } from '@reduxjs/toolkit'
import { BusinessParameters } from '../../../models';

const appApisSlice = createSlice({
  name: 'appApis',
  initialState: {
    parameters: {
      rawParameters: {},
      modeledParameters: {},
    },
  },
  reducers: {
    setParameters: (state, action) => {
      state.parameters = {
        rawParameters: action.payload,
        modeledParameters: new BusinessParameters(action.payload)
      };
    },
  },
})

export const {
  setParameters,
} = appApisSlice.actions;

export default appApisSlice.reducer;